<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
        <template #layoutContent>
            <div class="card card-flush h-lg-100 pt-5" id="kt_contacts_main" v-show="isReady">
                <div class="card-body p-0 m-0">
                    <div class="h-100 d-flex align-items-stretch flex-column mx-lg-15">
                        <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold">
                          <li class="nav-item">
                              <a class="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#kt_profil">
                              <i class="fonticon-user fs-1"></i>
                              {{  $t('user.profile') }}
                              </a>
                          </li>
                          <li class="nav-item">
                              <a class="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_change_password">
                              <i class="las la-user-edit fs-1"></i>
                              {{ $t('user.change_password') }}
                              </a>
                          </li> 
                          
                        </ul>
                        <div class="tab-content my-auto" id="myTabContent">
                            <div class="tab-pane fade show active" id="kt_profil" role="tabpanel">
                                <div class="card mb-5 mb-xl-10">
                                  <div id="kt_account_settings_profile_details" class="collapse show">
                                      <form id="kt_account_profile_details_form" class="form" @submit.prevent="submitEditProfilForm">
                                        <div class="card-body p-9">
                                            <RequiredText />
                                            <div class="row">
                                              <div class="col-12 col-md-3 col-lg-3 d-flex justify-content-center">
                                                <ImageInput v-model:image="formData.avatar" :model-image="formData.avatar_url" />
                                              </div>
                                              <div class="col-12 col-md-9 col-lg-9">
                                                <div class="row mb-6">
                                                <label class="col-lg-4 col-form-label required fw-bold fs-6">{{$t('user.gender')}}</label>
                                                <Select2
                                                    containerClass="col-lg-8 fv-row"
                                                    name="profile-gender"
                                                    :multiple="false"
                                                    selectClass="form-select form-select-solid"
                                                    :isRequired="true"
                                                    :placeholderText="$t('user.civility')"
                                                    v-model="formData.gender"
                                                >
                                                    <option value="female">{{ $t('user.female') }}</option>$
                                                    <option value="male">{{ $t('user.male') }}</option>
                                                </Select2>
                                                </div>
                                                <div class="row mb-6">
                                                <label class="col-lg-4 col-form-label required fw-bold fs-6">{{$t('user.lastname')}}</label>
                                                <div class="col-lg-8 fv-row">
                                                    <input v-model="formData.lastname" required type="text" name="fname" class="form-control form-control-lg form-control-solid mb-3 mb-lg-0"  />
                                                </div>
                                                </div>
                                                <div class="row mb-6">
                                                <label class="col-lg-4 col-form-label required fw-bold fs-6">{{$t('user.firstname')}}</label>
                                                <div class="col-lg-8 fv-row">
                                                    <input v-model="formData.firstname" required type="text" name="fname" class="form-control form-control-lg form-control-solid mb-3 mb-lg-0"  />
                                                </div>
                                                </div>
                                                <div class="row mb-6">
                                                  <label class="col-lg-4 col-form-label fw-bold fs-6">{{$t('user.initial')}}</label>
                                                  <div class="col-lg-8 fv-row">
                                                    <input v-model="formData.initials" type="text" name="initials" class="form-control form-control-lg form-control-solid mb-3 mb-lg-0" :placeholder="$t('user.initial_placeholder')" />
                                                  </div>
                                                </div>
                                                <div class="row mb-6">
                                                <label class="col-lg-4 col-form-label required fw-bold fs-6">{{ $t('user.email') }}</label>
                                                <div class="col-lg-8 fv-row">
                                                    <input type="email"  required v-model="formData.email" name="email" class="form-control form-control-lg form-control-solid"   />
                                                </div>
                                                </div>
                                                <div class="row mb-6">
                                                <label class="col-lg-4 col-form-label fw-bold fs-6">
                                                    <span class="required">{{  $t('user.phone') }}</span>
                                                </label>
                                                <InputTel
                                                    name="newUserPhone"
                                                    type="text"
                                                    containerClass="col-lg-8 fv-row"
                                                    inputClass="form-control form-control-sm form-control-solid"
                                                    v-model:phone="formData.phone"
                                                    v-model:phone-code="formData.phone_code"
                                                    :placeholder="$t('enter_phone')"
                                                    :isRequired="false" />
                                                </div>
                                              </div>
                                            </div>
                                        </div>
                                        <div class="card-footer d-flex justify-content-end py-6 px-9">
                                          <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.reset" size="7px 30px" @click.prevent="resetProfile"/>
                                          <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="isLoadingProfil"/>
                                        </div>
                                      </form>
                                  </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="kt_change_password" role="tabpanel">
                                <div class="card">
                                    <div id="kt_account_settings_signin_method" class="collapse show">
                                        <form  @submit.prevent="submitChangePasswordForm" id="kt_signin_change_password" class="form" >
                                        <div class="card-body">
                                            <RequiredText />
                                            <div class="d-flex flex-wrap align-items-center mt-5 mb-10">
                                                <div id="kt_signin_password_edit" class="flex-row-fluid ">
                                                    <div class="row mb-1">
                                                    <div class="col-lg-4">
                                                        <div class="fv-row mb-0">
                                                        <label for="currentpassword" class="form-label required fs-6 fw-bolder mb-3">{{  $t('user.old_password') }}</label>
                                                        <div class="password-input">
                                                            <input v-model="formEdit.old_password" autocomplete="off" class="form-control form-control-lg form-control-solid" :type="inputType" required name="currentpassword" id="currentpassword"/>
                                                            <span class="toggle-password" @click="togglePasswordVisibility">
                                                            <i :class="eyeIconClass"></i>
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <div class="fv-row mb-0">
                                                        <label for="newpassword" class="form-label required fs-6 fw-bolder mb-3">{{  $t('user.new_password') }}</label>
                                                        <div class="password-input">
                                                            <input v-model="formEdit.password" autocomplete="off" class="form-control form-control-lg form-control-solid" :type="inputType" required name="newpassword" id="newpassword"/>
                                                            <span class="toggle-password" @click="togglePasswordVisibility">
                                                            <i :class="eyeIconClass"></i>
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <div class="fv-row mb-0">
                                                        <label for="confirmpassword" class="form-label required fs-6 fw-bolder mb-3">{{  $t('user.cf_password') }}</label>
                                                        <div class="password-input">
                                                            <input v-model="formEdit.password_confirmation" autocomplete="off" class="form-control form-control-lg form-control-solid" :type="inputType" required name="confirmpassword" id="confirmpassword"/>
                                                            <span class="toggle-password" @click="togglePasswordVisibility">
                                                            <i :class="eyeIconClass"></i>
                                                            </span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div class="form-text mb-5">{{$t('auth.password_conditions')}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer d-flex justify-content-end ">
                                            <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="isLoading"/>
                                        </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </SubLayout>
</template>

<script>
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import { VueTelInput } from 'vue-tel-input'
import { mapActions , mapGetters } from 'vuex'
import InputTel from "@/components/InputTel.vue";
import Select2 from "@/components/Select2.vue";
import RequiredText from "@/components/RequiredText"
import ImageInput from "@/components/ImageInput.vue";
import Button from "@/components/Button.vue";
import moduleAbilities from "@/composables/moduleAbilities";
import Input from "@/components/Input.vue";


export default {

  components : {
    Input,
    // eslint-disable-next-line vue/no-unused-components
    SubLayout, Select2, InputTel, VueTelInput,
    RequiredText, ImageInput, Button
  },

  data(){
    return {
      title: i18n.global.t('breadcrumbs.profile'),
      breadcrumbs: [
        {
          name: i18n.global.t('breadcrumbs.profile'),
          path: '/'
        },
      ],
      formData: {
        gender: '',
        lastname: '',
        firstname: '',
        initials: '',
        email: '',
        phone : '',
        phone_code : '',
        avatar: null,
        avatar_url: null
      },
      formEdit : {
        old_password : "",
        password : "",
        password_confirmation : ""

      },
      isReady: false,
      showPassword: false,
      isLoading: false,
      isLoadingProfil: false,
      isLoadingReset: false,
      initialProfil: {}
    }
  },

  watch : {
    currentUser : function(value){
      if(value){
        this.initFormData(value)
      }
    }
  },

  async mounted () {
    this.isReady = false
    KTApp.initSelect2()
    this.initSelect2()
    await this.getCurrentUser().then((response) => this.initFormData(response.data))
    this.isReady = true

  },
  
  computed : {
    moduleAbilities() {
      return moduleAbilities
    },
    ...mapGetters('user', [
      'currentUser'
    ]),

    options(){
      return {
        placeholder: i18n.global.t('enter_phone'),
        showDialCode : false
      }
    },

    dropdownOptions(){
      return {
        showDialCodeInSelection: true,
        showDialCodeInList: true,
        showFlags: true
      }
    },

    inputType() {
      return this.showPassword ? 'text' : 'password';
    },

    eyeIconClass() {
      return this.showPassword ? 'fas fa-eye-slash' : 'fas fa-eye';
    },
  },

  methods: {
    ...mapActions('user', [
      'editProfil',
      'editPassword',
      'getCurrentUser'
    ]),

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    toggleNewPasswordVisibility() {
      this.showNewPassword = !this.showNewPassword;
    },

    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },

    initSelect2() {
      $(".kt_select2").select2()
      $(".kt_select2").select2().select2()

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'gender':
            this.formData.gender = e.target.value
            break;
          default:
            break;
        }
      });

    },

    async submitEditProfilForm(){
      this.isLoadingProfil = true
      let data = new FormData()
      data.append('gender',this.formData.gender)
      data.append('lastname',this.formData.lastname)
      data.append('firstname',this.formData.firstname)
      data.append('initials',this.formData.initials)
      data.append('email',this.formData.email)
      data.append('phone_code',this.formData.phone_code)
      data.append('phone',this.formData.phone)
      data.append('phone_code',this.formData.phone_code)
      if(this.formData.avatar  && this.formData.avatar instanceof File){
        data.append('avatar',this.formData.avatar)
      }else{
        data.append('avatar',null)
      }
      data.append('_method', 'POST');

      await this.editProfil(data).then((res) => {
        window.toastr['success'](i18n.global.t("notification.profil_updated"))
        this.isLoadingProfil = false

      }).catch(() => {
        this.isLoadingProfil = false
      })
    },

    async submitChangePasswordForm(){
      this.isLoading = true
      await this.editPassword(this.formEdit).then((res) => {
        window.toastr['success'](i18n.global.t("notification.password_updated"))

        this.formEdit = {
          old_password : "",
          password : "",
          password_confirmation : ""

        }
        this.isLoading = false

      }).catch(() => {
        this.isLoading = false
      })
    },

    thirstInputCountryChanged(country){
      this.formData.phone_code = '+' + country.dialCode
    },

    thirstInputChanged(number, phoneObject){
      let errorDiv = document.querySelector('[data-field="shop_phone"][data-field="shop_phone"][data-validator="callback"]')
      if(errorDiv){
        errorDiv.remove()
      }

      if(phoneObject){
        this.formData.phone =  phoneObject.nationalNumber
        this.formData.phone_code =   '+' + phoneObject.countryCallingCode
      }
    },

    resetProfile(){
      if (JSON.stringify(this.formData) !== JSON.stringify(this.initialProfil)) {
        this.formData = JSON.parse(JSON.stringify(this.initialProfil));
      }
    },

    initFormData(value) {
      this.formData = {
        gender: value.gender,
        lastname: value.lastname,
        firstname: value.firstname,
        initials: value.initials ? value.initials : value.initials_formatted,
        email: value.email,
        phone : value.phone || '',
        phone_code : value.phone_code,
        avatar: null,
        avatar_url: value.avatar_url,
      }

      this.initialProfil = {
        gender: value.gender,
        lastname: value.lastname,
        firstname: value.firstname,
        initials: value.initials ? value.initials : value.initials_formatted,
        email: value.email,
        phone : value.phone || '',
        phone_code : value.phone_code,
        avatar: null,
        avatar_url: value.avatar_url
      }
    }
  }

}
</script>

<style scoped>
  .password-input {
    position: relative;
  }

  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  #eye-icon {
    font-size: 1.2em;
  }
</style>
